import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface EditIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function EditIcon({ className, ...props }: EditIconProps) {
  return (
    <svg
      viewBox="0 0 14.1592 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      {...props}
    >
      <path d="M13.3955 13.4736C13.5978 13.4737 13.7925 13.5542 13.9355 13.6973C14.0784 13.8404 14.1592 14.0351 14.1592 14.2373C14.1591 14.4394 14.0783 14.6334 13.9355 14.7764C13.7925 14.9194 13.5978 14.9999 13.3955 15H0.763672C0.561383 15 0.366734 14.9193 0.223633 14.7764C0.0807824 14.6334 0.000127947 14.4394 0 14.2373C0 14.0349 0.0805082 13.8404 0.223633 13.6973C0.366757 13.5541 0.561265 13.4736 0.763672 13.4736H13.3955ZM9.69531 0C9.89751 6.84203e-06 10.0913 0.0807654 10.2344 0.223633L12.6162 2.60547V2.60645C12.759 2.74951 12.8398 2.9434 12.8398 3.14551C12.8397 3.34758 12.759 3.54158 12.6162 3.68457L4.875 11.4248C4.77916 11.5209 4.65962 11.5906 4.52832 11.625L1.30469 12.4668C1.17593 12.5004 1.04052 12.4997 0.912109 12.4648C0.783774 12.43 0.666336 12.3626 0.572266 12.2686C0.47826 12.1746 0.410892 12.057 0.375977 11.9287C0.341121 11.8003 0.340498 11.6649 0.374023 11.5361L1.21582 8.31055L1.24805 8.21484C1.2862 8.12169 1.34248 8.03656 1.41406 7.96484L9.15625 0.223633C9.29933 0.0807312 9.49309 1.94226e-05 9.69531 0ZM2.63867 8.89746L2.17871 10.6602L3.94141 10.2002L10.998 3.14453L9.69531 1.8418L2.63867 8.89746Z" fill="currentColor" />
    </svg>
  );
}
